<template>
    <!-- 使用手册 -->
    <div>
        <el-container>
            <el-aside width="280px">
                <Sidebar @menuClick="menuClickHandle" />
            </el-aside>
            <el-main>
                <div class="userBook">
                    <component :is="currentComponent" />

                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
// import Content from './components/Content.vue'
import RegisterAccount from './components/RegisterAccount.vue';
import LoginAccount from './components/LoginAccount.vue';
import PointsTopUp from './components/PointsTopUp.vue';
import PatentPlanMining from './components/PatentPlanMining.vue';

export default {
    components: {
        Sidebar,
        RegisterAccount,
        LoginAccount,
        PointsTopUp,
        PatentPlanMining
    },
    data() {
        return {
            currentComponent: 'RegisterAccount',
            menuComponentMap: {
                RegisterAccount: 'RegisterAccount',
                LoginAccount: 'LoginAccount',
                PointsTopUp: 'PointsTopUp',
                PatentPlanMining: 'PatentPlanMining'
            }
        }
    },
    methods: {
        menuClickHandle(item) {
            const componentName = this.menuComponentMap[item.name];
            if (componentName) {
                this.currentComponent = componentName; // 更新当前组件
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.el-aside {
    background-color: #ffffff;
    height: calc(100vh - 70px);
    border-right: 1px solid #e6e6e6;
    padding: 10px;
    box-sizing: border-box;
}

::v-deep .el-tree-node__label {
    font-size: 15px;
    color: #000;
}

::v-deep .el-tree-node__content {
    // margin-bottom: 10px;
    height: 35px;
}

::v-deep .el-tree-node:focus>.el-tree-node__content {
    background-color: #d6e7ff;
}

::v-deep .el-main {
    padding: 0 !important;
}

.userBook {
    flex: 1;
    padding: 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    overflow-y: auto !important;
    position: relative;
    max-height: calc(100vh - 70px);

}

/* 滚动条美化 */
.userBook::-webkit-scrollbar {
    width: 4px;
}

.userBook::-webkit-scrollbar-track {
    background: rgba(240, 240, 240, 0.3);
    border-radius: 3px;
}

.userBook::-webkit-scrollbar-thumb {
    background: rgba(163, 163, 163, 0.6);
    border-radius: 3px;
    transition: background 0.3s ease;
}

.userBook::-webkit-scrollbar-thumb:hover {
    background: rgba(120, 120, 120, 0.8);
}
</style>